const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

export const API_ENDPOINTS = Object.freeze({
  searchByLbs: `${API_BASE_URL}/searchByLbs`,
  searchPlaces: `${API_BASE_URL}/searchPlaces`,
  resolveStoreCode: `${API_BASE_URL}/resolveStoreCode`,
  searchByStoreCodeAndName: `${API_BASE_URL}/searchByStoreCodeAndName`,
  searchByCityCodeAndKeyword: `${API_BASE_URL}/searchByCityCodeAndKeyword`,
  getMenu: `${API_BASE_URL}/get_menu`,
  reverseGeocode: `${API_BASE_URL}/v3/geocode/regeo`
});
